import { updateFlow } from "../api";
import { TextInput, Button, Textarea, Box, Group, SegmentedControl, Text } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import ModelSelect from "../_Common/ModelSelect";

export default function FlowSettingsBase({ flow, setFlow }) {
  const form = useForm({
    mode: "uncontrolled",
    initialValues: flow,
    validate: {
      name: (val) => (/^[a-z0-9_]{2,49}[a-z0-9]$/.test(val) ? null : "Name must only contain lowercase letters, digits, and underscores, and be between 3 and 50 characters long"),
      title: isNotEmpty("Title cannot be empty"),
    },
  });
  return (
    <Box>
      <form
        onSubmit={form.onSubmit((values) => {
          updateFlow(flow.id, values).then((data) => {
            setFlow(data);
          });
        })}
      >
        <TextInput
          mt="sm"
          label="Flow Title"
          description="A human-readable name for this flow, shown in the dashboard and logs"
          placeholder="Document analysis"
          {...form.getInputProps("title")}
          key={form.key(`title`)}
          radius="md"
        />

        <TextInput
          mt="sm"
          label="Flow Name"
          description="Machine-readable identifier used in API calls (lowercase, underscores only)"
          placeholder="document_analysis"
          {...form.getInputProps("name")}
          key={form.key(`name`)}
          radius="md"
        />

        <Textarea
          mt="sm"
          label="Flow Description"
          description="Optional notes about the purpose and usage of this flow"
          autosize
          minRows={2}
          maxRows={5}
          placeholder="Prompts related to analysis of SEC standard publications"
          {...form.getInputProps("description")}
          key={form.key(`description`)}
          radius="md"
        />

        <Box mt="sm">
          <Text size="sm" fw={500} mb={4}>Execution Mode</Text>
          <Text size="xs" c="dimmed" mb="xs">
            Direct runs the entrypoint template. Route uses an LLM classifier to pick the best template based on user input.
          </Text>
          <SegmentedControl
            data={[
              { value: "direct", label: "Direct" },
              { value: "route", label: "Route" },
            ]}
            value={form.values.executionMode === "route" || form.values.executionMode === 1 ? "route" : "direct"}
            onChange={(val) => form.setFieldValue("executionMode", val)}
            key={form.key("executionMode")}
          />
        </Box>

        {(form.values.executionMode === "route" || form.values.executionMode === 1) && (
          <ModelSelect
            mt="sm"
            label="Classifier Model"
            description="A fast/cheap model for classification (e.g. gpt-4o-mini). Leave empty for default."
            {...form.getInputProps("classifierModel")}
            key={form.key("classifierModel")}
          />
        )}

        <Group justify="flex-end">
          <Button mt="lg" type="submit">
            Save flow
          </Button>
        </Group>
      </form>
    </Box>
  );
}
